import { Route, Routes } from "react-router-dom";
import { EmployeeDetails } from "../Employee/EmployeeDetails/EmployeeDetails";
import { EmployeeEdit } from "../Employee/EmployeeEdit/EmployeeEdit";
import { UserRoles } from "../../constants/userRoles";
import { PrivateRoute, useUser } from "../../keycloak";
import { EmployeeRoles } from "../../models/Employee";
import { ClientDetails } from "../Sales/Client/ClientDetails/ClientDetails";
import { ClientEdit } from "../Sales/Client/ClientEdit/ClientEdit";

export function Profile() {
  const user: any = useUser();

  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.PROFILE_VIEW],
            }}
          />
        }
      >
        <Route
          path="/"
          element={
            user?.role === EmployeeRoles.CLIENT ? (
              <ClientDetails isOwn />
            ) : (
              <EmployeeDetails isOwn />
            )
          }
        />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.PROFILE_VIEW],
            }}
          />
        }
      >
        <Route
          path="/edit"
          element={
            user?.role === EmployeeRoles.CLIENT ? (
              <ClientEdit isOwn />
            ) : (
              <EmployeeEdit isOwn />
            )
          }
        />
      </Route>
    </Routes>
  );
}
